import React, { useState } from "react";

const Contact = () => {
    const [showProductDetails, setShowProductDetails] = useState(false);

    // Function to handle the click on the terms and conditions link
    const handleClick = () => {
      // Show product details when Terms and Conditions are clicked
      setShowProductDetails(true);
  
      // Set a timer to hide the product details after 5 seconds (for example)
      setTimeout(() => {
        setShowProductDetails(false);
      }, 50000); // 5000ms = 5 seconds
    };

     const listStyle = {
        listStyleType: 'none',
        padding: '0',
      };
    
      const listItemStyle = {
        fontSize: '1.1rem',
        marginBottom: '10px',
      };
      const subHeadingStyle = {
        fontSize: '2rem',
        marginTop: '30px',
        marginBottom: '10px',
        textAlign: 'center',
      };
  
    return (
      <div>
        {/* Terms and Conditions anchor */}
        <a href="#contact" onClick={handleClick}>
          Contact Us
        </a>
  
        {/* Product Details section */}
        {showProductDetails && (
          <div className="product-details">
            <h2 style={subHeadingStyle}>Contact</h2>
            <ul style={listStyle}>
            <li style={listItemStyle}>Address: Sreerampur Rail gate, Raipura, Narsingdi.</li>
            <li style={listItemStyle}>Phone Number: 01729409507</li>
            <li style={listItemStyle}>Email: noorimranahamad@gmail.com</li>
            </ul>
          </div>
        )}
      </div>
    );
  
};

export default Contact;